const stickyViews = ["tableview", "crosstab", "calendar", "kanban"];

const generateClassList = suffix => stickyViews.map(c => `.v3-${c}-${suffix}`).join(",");

function ensureVisible(hashOrElement) {
	if (!hashOrElement) return;
	let targetElement;
	if (typeof hashOrElement === "string") {
		targetElement = document.getElementById(hashOrElement.slice(1));
		if (!targetElement) return;
	} else {
		targetElement = hashOrElement;
	}

	const scrollElement = document.body;

	let safeAreaTop = parseFloat(document.documentElement.style.getPropertyValue("--v3-sys-topnav-height")) || 0;
	// top navigation covers the part of the page
	const stickyCaptionView = targetElement.closest(".v3-sticky-caption");
	if (stickyCaptionView) {
		if (stickyCaptionView.getBoundingClientRect().top <= safeAreaTop) {
			const captionPresent = 1; // stickyCaptionView.style.getPropertyValue("--v3-sys-caption-present");
			const captionHeight = parseFloat(stickyCaptionView.style.getPropertyValue("--v3-sys-caption-height")) || 0;
			const tableHeadHeight = parseFloat(stickyCaptionView.style.getPropertyValue("--v3-sys-table-head-height")) || 0;
			safeAreaTop += captionPresent * captionHeight + tableHeadHeight;
		}
		const dataGroup = targetElement.closest(generateClassList("group"));
		const dataGroupHead = dataGroup?.previousElementSibling.matches(generateClassList("grouphead")) && dataGroup.previousElementSibling;
		if (dataGroupHead) {
			const dataGroupHeadRect = dataGroupHead.getBoundingClientRect();
			if (dataGroupHeadRect.top <= safeAreaTop)
				safeAreaTop += dataGroupHeadRect.height;
		}
	}
	setTimeout(() => {
		let { top: frameTop, bottom: frameBottom } = scrollElement.getBoundingClientRect();
		frameTop += safeAreaTop;
		const { top: targetTop, bottom: targetBottom } = targetElement.getBoundingClientRect();
		let deltaTop = 0;
		if (targetTop < frameTop) {
			deltaTop = targetTop - frameTop;
		} else if (targetBottom > frameBottom) {
			deltaTop = targetBottom - frameBottom;
		}
		if (deltaTop) {
			// console.log("Frame top", frameTop, "target top", targetTop, "delta", deltaTop);
			scrollElement.scroll({ left: 0, top: scrollElement.scrollTop + deltaTop, behavior: "smooth" });
		}
	});
}

export { ensureVisible };
